import { z } from 'zod';
import { c } from '../../contract';

export const customerSupportRouter = c.router({
  userCalls: {
    isUserASuperfan: {
      summary: 'Checks if a user is a superfan',
      method: 'GET',
      path: '/cs/user-calls/:userId/superfan',
      responses: {
        200: z.object({
          isSuperfan: z.boolean(),
        }),
      },
    },
    eligibility: {
      summary: 'Checks if a user is eligible for a user-call opt-in',
      method: 'GET',
      path: '/cs/user-calls/:userId',
      responses: {
        200: z.object({
          isEligible: z.boolean(),
          isSuperfan: z.boolean(),
        }),
      },
    },
  },
});
